import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const faqs = [
  {
    q: "ไม่มีพื้นฐาน BAZI เลย เรียนทันไหม?",
    a: "ทันแน่นอน หลักสูตรออกแบบให้เริ่มจากศูนย์ และใช้ซอฟต์แวร์คำนวณให้ในห้องเรียน คุณจึงโฟกัสที่การตีความผลลัพธ์เพื่อใช้กับการเงินได้ทันที ไม่ต้องท่องจำสูตรคำนวณเอง"
  },
  {
    q: "ต้องเตรียมอุปกรณ์อะไรไปเรียนบ้าง?",
    a: "เตรียมโน้ตบุ๊กหรือแท็บเล็ตสำหรับใช้ในช่วง Workshop และข้อมูลวันเดือนปีเวลาเกิดของตัวเอง ส่วนเอกสารและอาหารทางผู้จัดเตรียมให้ครบ"
  },
  {
    q: "ราคา Early Bird มีจำนวนจำกัดแค่ไหน?",
    a: "ราคาพิเศษมอบให้กับ 3 ท่านแรกที่โอนเงินและแนบหลักฐานเท่านั้น เมื่อครบจำนวน ระบบจะปรับเป็นราคาปกติโดยอัตโนมัติ"
  },
  {
    q: "เนื้อหาความรู้ลับเสริมมั่งคั่ง เชื่อได้แค่ไหน?",
    a: "เนื้อหาส่วนนี้เป็นความรู้เชิงวัฒนธรรมและความเชื่อที่สืบทอดมาจากหลายสาย ใช้เป็นข้อมูลประกอบการตัดสินใจเท่านั้น ไม่ใช่การรับประกันผลลัพธ์ทางการเงิน"
  }
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section className="section-padding bg-white">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-brand-red font-bold uppercase tracking-widest text-sm mb-4 block">Frequently Asked Questions</span>
          <h2 className="text-4xl md:text-5xl font-black text-zinc-900">ก่อนตัดสินใจ อ่านตรงนี้ก่อน</h2>
        </div>

        <div className="border-t border-zinc-200">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-zinc-200">
              <button 
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full py-6 text-left flex justify-between items-center focus:outline-none hover:text-brand-red transition-colors"
              >
                <span className="font-bold text-lg pr-8">{faq.q}</span>
                <span className={`text-2xl font-light transition-transform duration-300 ${openIndex === index ? 'rotate-45 text-brand-red' : 'text-zinc-400'}`}>+</span>
              </button>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div 
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    className="overflow-hidden"
                  >
                    <div className="pb-8 text-zinc-600 font-medium leading-relaxed">
                      {faq.a}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}